import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "basicOfferEndBackground d-flex justify-center ml-2" }
const _hoisted_2 = { class: "basicOfferBackground d-flex justify-center ml-2" }
const _hoisted_3 = { class: "essentialOfferEndBackground d-flex justify-center ml-2" }
const _hoisted_4 = { class: "essentialOfferBackground d-flex justify-center ml-2" }
const _hoisted_5 = { class: "premiumOfferEndBackground d-flex justify-center ml-2" }
const _hoisted_6 = { class: "premiumOfferBackground d-flex justify-center ml-2" }
const _hoisted_7 = { class: "essentialOfferEndBackground d-flex justify-center ml-2" }
const _hoisted_8 = { class: "essentialOfferBackground d-flex justify-center ml-2" }
const _hoisted_9 = { class: "d-flex justify-center pt-4" }
const _hoisted_10 = { class: "d-flex justify-center pt-4" }
const _hoisted_11 = { class: "d-flex justify-center pt-4" }
const _hoisted_12 = { class: "d-flex justify-center pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "offerTitleBackground"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center basicOfferTitle" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" STANDARD ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "offerTitleBackground"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center essentialOfferTitle" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" ESSENTIEL ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "offerTitleBackground"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center premiumOfferTitle" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" PREMIUM ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "offerTitleBackground"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tooltip, null, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_sheet, _mergeProps(props, { class: "d-flex justify-center align-center premiumOfferTitle" }), {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" TRAINING* ")
                    ])),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.description-text")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        style: _normalizeStyle({ 'overflow-y': 'auto', 'max-height': _ctx.heightMax, 'overflow-x': 'hidden' }),
        dense: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheme, (category, categories_index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: categories_index }, [
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, { class: "titleCategory" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(category.title), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (category.basicOffer && category.basicOffer.colorised)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "2",
                            class: "pt-0 pb-0"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createElementVNode("div", { class: "basicOfferBackground ml-2" }, null, -1)
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "2"
                          })),
                      (category.essentialOffer && category.essentialOffer.colorised)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "2",
                            class: "pt-0 pb-0"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("div", { class: "essentialOfferBackground ml-2" }, null, -1)
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_col, {
                            key: 3,
                            cols: "2"
                          })),
                      (category.premiumOffer && category.premiumOffer.colorised)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 4,
                            cols: "2",
                            class: "pt-0 pb-0"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("div", { class: "premiumOfferBackground ml-2" }, null, -1)
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_col, {
                            key: 5,
                            cols: "2"
                          })),
                      (category.trainingOffer && category.trainingOffer.colorised)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 6,
                            cols: "2",
                            class: "pt-0 pb-0"
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createElementVNode("div", { class: "essentialOfferBackground ml-2" }, null, -1)
                            ])),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_col, {
                            key: 7,
                            cols: "2"
                          }))
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.categories, (subCategory, index) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      key: categories_index * 10000 + (index + 1),
                      dense: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, { class: "titleSubCategory" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subCategory.title), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (
                                subCategory.basicOffer &&
                                subCategory.basicOffer.colorised &&
                                subCategory.basicOffer.isEnd
                            )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: "pt-0 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  (subCategory.basicOffer && subCategory.basicOffer.valid)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        class: "basicOfferIcon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subCategory.basicOffer.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : (subCategory.basicOffer && subCategory.basicOffer.colorised)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "2",
                                class: "pt-0 pb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    (subCategory.basicOffer && subCategory.basicOffer.valid)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "basicOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.basicOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                cols: "2"
                              })),
                        (
                                subCategory.essentialOffer &&
                                subCategory.essentialOffer.colorised &&
                                subCategory.essentialOffer.isEnd
                            )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "2",
                              class: "pt-0 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  (
                                        subCategory.essentialOffer &&
                                        subCategory.essentialOffer.valid
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        class: "essentialOfferIcon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subCategory.essentialOffer.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : (
                                subCategory.essentialOffer && subCategory.essentialOffer.colorised
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 4,
                                cols: "2",
                                class: "pt-0 pb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    (
                                        subCategory.essentialOffer &&
                                        subCategory.essentialOffer.valid
                                    )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "essentialOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.essentialOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 5,
                                cols: "2"
                              })),
                        (
                                subCategory.premiumOffer &&
                                subCategory.premiumOffer.colorised &&
                                subCategory.premiumOffer.isEnd
                            )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 6,
                              cols: "2",
                              class: "pt-0 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  (
                                        subCategory.premiumOffer && subCategory.premiumOffer.valid
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        class: "premiumOfferIcon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subCategory.premiumOffer.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : (
                                subCategory.premiumOffer && subCategory.premiumOffer.colorised
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 7,
                                cols: "2",
                                class: "pt-0 pb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    (
                                        subCategory.premiumOffer && subCategory.premiumOffer.valid
                                    )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "premiumOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.premiumOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 8,
                                cols: "2"
                              })),
                        (
                                subCategory.trainingOffer &&
                                subCategory.trainingOffer.colorised &&
                                subCategory.trainingOffer.isEnd
                            )
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 9,
                              cols: "2",
                              class: "pt-0 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  (
                                        subCategory.trainingOffer && subCategory.trainingOffer.valid
                                    )
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        class: "essentialOfferIcon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subCategory.trainingOffer.icon), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : (
                                subCategory.trainingOffer && subCategory.trainingOffer.colorised
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 10,
                                cols: "2",
                                class: "pt-0 pb-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    (
                                        subCategory.trainingOffer && subCategory.trainingOffer.valid
                                    )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          class: "essentialOfferIcon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subCategory.trainingOffer.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 11,
                                cols: "2"
                              }))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.isDisplayPrice)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("p", { class: "d-flex justify-end pt-4" }, "prix mensuel:", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.basicPrice) + "€*", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.essentialPrice) + "€*", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.premiumPrice) + "€*", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.trainingPrice) + "€*", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}